export const parseRecaptchaError = (reasons) =>
  reasons.some((errorType) => errorType === 'missing-input-secret' ||
    errorType === 'invalid-input-secret' || errorType === 'bad-request');
